import { Fragment, useContext } from "react";

import { useTranslation } from "react-i18next";

import { FT } from "components/Actions/dialogs/DeviceGroups/ManageGroup/content/AddFiles/constants";
import CardItemValue from "components/TableDetails/components/CardItemValue";
import { TitleInfo } from "components/TableDetails/components/TitleInfo";
import { renderAvailableData } from "components/TableDetails/functions";
import TableContext from "context/table/tableContext";
import { FILE_TYPES } from "shared";

import { FT_PLATFORM_FILES, MAIN_CONFIGURATION } from "../constants";
import { DeviceGroupDetailsData } from "../types";

const FtPlatformFiles = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();

    const {
        ft_bluetooth_auth_list_file,
        ft_configuration,
        ft_firmware,
        ft_one_wire_auth_list_file
    }: DeviceGroupDetailsData = detailsData;

    const list = [
        {
            title: FILE_TYPES.Firmware,
            value: ft_firmware?.name,
            isAvailable: true
        },
        {
            title: MAIN_CONFIGURATION,
            value: ft_configuration?.name,
            isAvailable: true
        },
        {
            title: FILE_TYPES.OneWireAuthorizationList,
            value: ft_one_wire_auth_list_file?.name,
            isAvailable: true
        },
        {
            title: FILE_TYPES.BluetoothAuthorizationList,
            value: ft_bluetooth_auth_list_file?.name,
            isAvailable: true
        }
    ];

    return (
        <div>
            <div>
                {t("Dialog##smart group##title", {
                    platformName: FT
                })}

                <TitleInfo
                    aria-label={t("Dialog##smart group##title", {
                        platformName: FT
                    })}
                    cardName={FT_PLATFORM_FILES}
                    list={list}
                />
            </div>

            <div>
                {renderAvailableData(list).map(({ title, value }) => {
                    return (
                        <Fragment key={title}>
                            <span>{t(`General##${title}`)}:</span>
                            <CardItemValue value={value} />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export { FtPlatformFiles };
